import { render } from "./DarkThemeToggle.vue?vue&type=template&id=22a17876"
import script from "./DarkThemeToggle.vue?vue&type=script&lang=js"
export * from "./DarkThemeToggle.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__